import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import server from '../libs/server/server';
import Client from '../views/Client';

Vue.use(VueRouter);

const serverInstance = server();

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    props: { server: serverInstance },
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/playground',
    name: 'Playground',
    component: () =>
      import(/* webpackChunkName: "playground" */ '../views/Playground.vue'),
  },
  {
    path: '/:destPeerId',
    name: 'Client',
    component: Client,
    props: (route) => {
      return {
        destPeerId: route.params.destPeerId,
        server: serverInstance,
      };
    },
  },
  { path: '*', redirect: { name: 'Home' } },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
